import { useState } from "react";
import { useNavigate } from "react-router-dom";
import APIRequest from "../../../../Services/commonAPIConsumer";
import { useSelector } from "react-redux";
import { storeSettingsData, excludeControls } from "../../../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";

export function useFetchSettings() {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector(currentSelectedLanguage);
  let searchedCompany = useSelector((state) => state.settings.searchedCompany);
  let searchedUser = useSelector((state) => state.settings.searchedUser);
  const settingFor = useSelector((state) => state.settings.settingFor);
  const userRole = localStorage.getItem("UserRole");

  const getActiveTabSettings = async (tabMenuText, userName, companyName) => {
    try {
      let level = settingFor;
      if (searchedUser === "" || searchedCompany === "") {
        searchedUser = userName;
        searchedCompany = companyName;
      }
      if (settingFor === "Admin") {
        level = "Company";
      }

      if (
        settingFor === "Admin" &&
        tabMenuText === "Document"
      ) {
        level = "Global";
      }
      const user = (searchedUser || "").toLowerCase();
      let url = "";
      if (
        tabMenuText === "DirectSendDefaults"
      ) {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetGatewaySettingDetails
          }?SettingFor=${settingFor}&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      } else if (tabMenuText === "Profile") {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetSettingDetails
          }?SettingFor=profile&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      } else if (tabMenuText === "Document") {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetSettingDetails
          }?SettingFor=${level}&Lang=${localStorage.getItem(
            "language"
          )}`;
      } else {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetSettingDetails
          }?SettingFor=${level}&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      }

      if (
        searchedUser &&
        searchedUser !== "" &&
        searchedCompany &&
        searchedCompany !== ""
      ) {
        url += `&company=${searchedCompany}&userEmail=${user}`;
      } else if (searchedCompany && searchedCompany !== "") {
        url += `&company=${searchedCompany}`;
      } else if (searchedUser && searchedUser !== "") {
        url += `&userEmail=${user}`;
      }
      let response = await APIRequest.GET("", url);
      if (response && response.errorMessage) {
        return response.errorMessage;
      }
      localStorage.setItem("IsDirectSendDefaults", response.isDirectSendDefault);
      localStorage.setItem("IsContentSecurity", response.isContentSecurity);

      const settingsData = {
        outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
        innerTabSelected: tabMenuText,
        Settings: null,
      };

      if (
        tabMenuText === "Profile" &&
        response?.userDetails
      ) {
        settingsData.Settings = response.userDetails;
      } else if (response?.setting) {
        const isDirectSend = tabMenuText === "DirectSendDefaults";
        const isContentSecurity = tabMenuText === "ContentSecurity";
        const mapSettings = (settings) =>
          settings.map((setting) => {
            const mapped = {
              ...setting,
              prevValue: setting.keyValue,
              prevOverride:
                setting[isDirectSend ? "isOverride" : "overrideUserSetting"],
              prevLock: setting[isDirectSend ? "isLock" : "lockSetting"],
            };
            // Responsible for capturing and normalizing initial IPChangeDetectionOptions for change detection
            if (setting.type === "IPChangeDetection") {
              const opts = setting.ipChangeDetectionOptions || setting.IPChangeDetectionOptions || {
                banReader: false,
                reAuthenticateReader: false,
                notifySender: false,
              };
              const normalizedOpts = {
                banReader: opts.banReader === true || opts.BanReader === true,
                reAuthenticateReader: opts.reAuthenticateReader === true || opts.ReAuthenticateReader === true,
                notifySender: opts.notifySender === true || opts.NotifySender === true,
              };
              mapped.ipChangeDetectionOptions = normalizedOpts;
              mapped.IPChangeDetectionOptions = {
                BanReader: normalizedOpts.banReader,
                ReAuthenticateReader: normalizedOpts.reAuthenticateReader,
                NotifySender: normalizedOpts.notifySender,
              };
              mapped.prevIPChangeDetectionOptions = { ...normalizedOpts };
              mapped.keyCollection = [];
            }
            return mapped;
          });

        if (
          isDirectSend
        ) {
          response.setting = response.setting.map((setting) => {
            setting.commonSettings = mapSettings(setting.commonSettings);
            setting.l1 = mapSettings(setting.l1);
            setting.l2 = mapSettings(setting.l2);
            setting.l3 = mapSettings(setting.l3);
            return setting;
          });
        } else if (isContentSecurity) {
          response.setting = response.setting.map((setting) => {
            setting.commonContentSecuritySetting = mapSettings(setting.commonContentSecuritySetting);
            setting.cipherText = mapSettings(setting.cipherText);
            setting.floatingText = mapSettings(setting.floatingText);
            return setting;
          });
        }
        else {
          if (settingFor !== "Admin" && tabMenuText !== "Document") {
            const landingPage = response.setting.find(s => s.type === "LandingPage") || {};
            let landingPageValue = "";
            if (landingPage.keyValue.includes('_')) {
              landingPageValue = landingPage.keyValue.split('_')[1];
            } else {
              landingPageValue = "All Items";
            }
            const manageItem = {
              type: "LandingPage_ManageItem",
              keyValue: landingPageValue,
              overrideUserSetting: landingPage.overrideUserSetting,
              lockSetting: landingPage.lockSetting,
              id: landingPage.id
            }
            response.setting.push(manageItem);
            response.setting = mapSettings(response.setting);
            response.setting = response.setting.map(function (setting) {
              if (setting.type === "EDisclosure" && Array.isArray(setting.keyCollection)) {
                return Object.assign({}, setting, {
                  keyCollection: setting.keyCollection.map(function (level) {
                    return Object.assign({}, level, { prevLevelFlag: level.levelFlag });
                  }),
                });
              }
              return setting;
            });
            const controlsToExclude = [];

            controlsToExclude.push('MaxPagesPerRPD', 'ImageResolution');

            const maxViewsSetting = response.setting.find(s => s.type === 'maxViewsPerDocument');
            if (maxViewsSetting?.lockSetting === "true") {
              controlsToExclude.push('maxViewsPerDocument');
            }

            dispatch(excludeControls({ value: controlsToExclude }));
          }
        }
        settingsData.Settings = mapSettings(response.setting);
      }

      if (settingsData.Settings) {
        dispatch(storeSettingsData(settingsData));
      }
      return true;
    } catch (error) {
      console.log(error);
    }
  };

  return { getActiveTabSettings };
}

export default useFetchSettings;
